import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import DefaultActionButton from 'components/Buttons/ActionButton';

import { Body } from 'components/Typography';
import DefaultSelectAdd from 'components/Form/SelectAdd';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  padding: 2rem;
  border-radius: 1.5rem;
`;

export const SelectAdd = styled(DefaultSelectAdd)``;

// TODO: TFR-44 move to placeholder group
export const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const PlaceholderText = styled(Body)``;

// TODO: TFR-49 split components into two or more different logical components
export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 4rem;
  border: 1px solid ${({ theme }) => theme.colors.gray2};
  border-bottom-style: none;
  padding: 1rem;

  &:first-child {
    border-radius: 0.75rem 0.75rem 0 0;
  }

  &:last-child {
    border-radius: 0 0 0.75rem 0.75rem;
    border-bottom-style: solid;
  }

  &:only-of-type {
    border-radius: 0.75rem;
  }
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Name = styled(Body)``;
export const ActionButton = styled(DefaultActionButton)`
  border: none;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;
